import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './i18n'; // Importar configuração de internacionalização
import App from './App';

// Criar a raiz da aplicação React
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderizar a aplicação
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 